/* unplugin-vue-components disabled */import script from "./BindMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BindMobile.vue?vue&type=script&setup=true&lang=js"

import "./BindMobile.vue?vue&type=style&index=0&id=1d1af44b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1af44b"]])

export default __exports__